import { FC } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import TimePicker from 'src/view/components/Controls/Pickers/TimePicker/TimePicker';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { IPosIntRestriction } from '~/types/integrations';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';

interface IProps {
  title: string;
  time: Date;
  disabled: boolean;
  posIntRestriction: IPosIntRestriction;
  error: boolean;
  className?: string;
  onChange: (time: Date) => void;
}

const WorkingHoursTimePicker: FC<IProps> = ({ title, time, disabled, posIntRestriction, error, className = '', onChange }): JSX.Element => {
  return (
    <div className={`d-flex flex-column ${className}`}>
      <Text text={title} type={TEXT.COLUMN_TITLE} disabled={posIntRestriction.shouldDisable || disabled} />

      <IntegrationManager
        setting={posIntRestriction.access}
        withTooltip
        tooltipOptions={{ show: posIntRestriction.shouldDisable, minWidth: 355, position: TOOLTIP_POSITION.PORTAL }}
      >
        <TimePicker date={time} disabled={disabled} error={error} className="mt-1" onTimeChanged={onChange} />
      </IntegrationManager>

      {error && <p className="family-regular text-size-14 color-red mt-2">{localeStore.t('timeslot_is_superimposed_error')}</p>}
    </div>
  );
};

export default WorkingHoursTimePicker;
